<div class="g-modal-v2 login-modal">
  <div class="g-modal-v2-header">
    <div class="g-modal-v2-title">
      {{ 'global.login' | translate }}
    </div>

    <button
      class="g-modal-v2-close"
      (click)="dialogRef.close({ type: 'CANCEL' })"
    >
      <tc-icon name="close" />
    </button>
  </div>

  <div class="g-modal-v2-content">
    <login
      (loggedIn)="dialogRef.close({ type: 'CONFIRM' })"
    >
    </login>
  </div>
</div>
